import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {FormattedMessage, useIntl} from "react-intl";
import NavigationBar from "../../../../../components/NavigationBar";
import HomeIcon from "@mui/icons-material/Home";
import {RoutePath} from "../../../../../constants/RoutePath";
import {Button} from "@mui/material";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import LoginUIDForm from "../../../../account/user/login/components/LoginUIDForm";
import {AuthType} from "../../../../../modules/account/enums/AuthType";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {CaptchaDto} from "../../../../../modules/account/dto/CaptchaDto";
import {ValidateUtils} from "../../../../../utils/ValidateUtils";
import {UserApi} from "../../../../../modules/account/api/UserApi";
import {AccountCacheKey} from "../../../../../modules/account/constants/AccountCacheKey";
import {HttpUtils} from "../../../../../utils/HttpUtils";
import {useNavigate} from "react-router-dom";
import {WeChatAuthApi} from "../../../../../modules/wechat/api/WeChatAuthApi";

const Index: React.FC = () => {

    const intl = useIntl();

    const navigate = useNavigate();

    const [authType, setAuthType] = React.useState(AuthType.Enum.UID);
    const [user, setUser] = useState<UserDto>(new UserDto());
    const [captcha, setCaptcha] = useState<CaptchaDto>(new CaptchaDto());
    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    const [wechatOpenId, setWechatOpenId] = useState("");

    useEffect(() => {
        // 微信网页授权会携带code，然后通过后台获取openID，提交的时候把该openID跟访客绑定
        const wxOAuthCode = HttpUtils.getQueryString(window.location.href, "wxOAuthCode");
        if (wxOAuthCode) {
            _handleGetWeChatOpenId(wxOAuthCode);
        }
    }, []);

    const _handleGetWeChatOpenId = async (wxOAuthCode: string) => {
        const responseResult = await WeChatAuthApi.getOAuth2AccessToken(wxOAuthCode);
        if (responseResult.status === HttpStatus.SUCCESS) {
            console.log(responseResult.data);
            setWechatOpenId(responseResult.data.openid);
        }
    }

    const _handleChangeUser = (name: string, value: any) => {
        setUser({...user, [name]: value});
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (authType === AuthType.Enum.UID) {
            if (user.uid === '') {
                newMessageMap.set('uid', intl.formatMessage({id: 'ACCOUNT_USER_UID_REQUIRED'}));
            }
            if (user.password === '') {
                newMessageMap.set('password', intl.formatMessage({id: 'ACCOUNT_USER_PASSWORD_REQUIRED'}));
            }
        } else if (authType === AuthType.Enum.Email) {
            if (user.email === '') {
                newMessageMap.set('email', intl.formatMessage({id: 'ACCOUNT_USER_EMAIL_REQUIRED'}));
            } else if (!ValidateUtils.isEmail(user.email)) {
                MessageUtils.error(intl.formatMessage({id: 'ACCOUNT_USER_EMAIL_FORMAT_WRONG'}));
            }
            if (captcha.captchaValue === '') {
                newMessageMap.set('captchaValue', intl.formatMessage({id: 'ACCOUNT_USER_CAPTCHA_REQUIRED'}));
            }
        }
        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const _handleLogin = async () => {
        if (validate()) {
            // 登录
            const responseResult = await UserApi.login(user, authType, captcha.captchaValue);
            if (responseResult.status === HttpStatus.SUCCESS) {

                console.log(wechatOpenId);
                if (wechatOpenId) {
                    _handleBindOpenId(wechatOpenId);
                }
                if (window.location.href.includes('redirect')) {
                    const redirectUrl = HttpUtils.getQueryString(window.location.href, "redirect");
                    console.log(redirectUrl);
                    window.location.href = redirectUrl;
                } else {
                    // 登录成功重定向到首页
                    navigate(RoutePath.VMS_MOBILE_EMPLOYEE_HOME);
                }
            }
        }
    }

    const _handleBindOpenId = async (wechatOpenId: string) => {
        const responseResult = await UserApi.getSessionUser();
        console.log(responseResult);
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            const sessionUser = responseResult.data;
            sessionUser.wxOpenId = wechatOpenId;
            console.log(sessionUser);
            UserApi.updateSessionUser(sessionUser);
        }
    }

    return (
        <div>
            <NavigationBar leftIcon={<HomeIcon/>}
                           leftIconClick={() => navigate(RoutePath.VMS_MOBILE_WELCOME)}
                           title={intl.formatMessage({id: "ACCOUNT_USER_LOGIN"})}/>
            <div style={{padding: "1rem"}}>
                <LoginUIDForm user={user} messageMap={messageMap}
                              onChange={(name, value) => _handleChangeUser(name, value)}/>
                <br/>
                <Button variant="outlined" fullWidth={true} onClick={() => _handleLogin()} color="primary">
                    <FormattedMessage id={'ACCOUNT_USER_LOGIN'}/>
                </Button>
            </div>
        </div>
    );
};

export default Index;
